import { Badge } from "@/components/ui/badge";
import type { AccountStatus } from "@/lib/types";

const map: Record<AccountStatus, { variant: "default" | "success" | "warning" | "destructive" | "secondary" | "outline"; label: string }> = {
  new: { variant: "secondary", label: "new" },
  active: { variant: "success", label: "active" },
  cooldown: { variant: "warning", label: "cooldown" },
  frozen: { variant: "destructive", label: "frozen" },
  banned: { variant: "destructive", label: "banned" },
  disabled: { variant: "outline", label: "disabled" },
  no_proxy: { variant: "warning", label: "no proxy" },
};

export function AccountStatusBadge({ status, title }: { status: AccountStatus; title?: string }) {
  const v = map[status] ?? map.disabled;
  return <Badge variant={v.variant} title={title}>{v.label}</Badge>;
}
